import { GaIconAdditionalCartAdd } from '@ga/icons'

import { GaButtonIconOnly } from '@ga/ui-components/button-icon-only'

import { useApp } from '~/modules/app'

import { SIZE } from './scripts/consts'

// @vue/component
export default {
  name: 'ga-product-card-cart-button',

  components: {
    GaIconAdditionalCartAdd,
    GaButtonIconOnly,
  },

  props: {
    size: {
      type: String,
      default: SIZE.S,
      validator: (value) => Object.values(SIZE).includes(value),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    testId: {
      type: String,
      default: '',
    },
  },

  emits: ['click'],

  setup(props) {
    const { size } = toRefs(props)

    const { appWithHover } = useApp()

    const buttonSize = computed(() => {
      return { s: 's', m: 'l' }[unref(size)]
    })

    const mods = computed(() => ({
      touchable: !unref(appWithHover),
    }))

    return {
      mods,
      buttonSize,
    }
  },
}
